import schedulesViewStateStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_FEATURE_CLICKED_BEFORE_DATA_FETCHED', function setfeatureClickedBeforeDataFetched(
    userClicked: boolean
) {
    schedulesViewStateStore().featureClickedBeforeDataFetched = userClicked;
});
